var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48485 31.2955C2.47475 32.25 3.67677 32.7273 5.09091 32.7273H20.7502C19.6987 31.8402 18.8472 30.7235 18.2731 29.4545H5.09091C4.6101 29.4545 4.20707 29.2977 3.88182 28.9841C3.55657 28.6705 3.39394 28.2818 3.39394 27.8182V26.1818H17.4689C17.4584 26.0014 17.4531 25.8196 17.4531 25.6365C17.4531 24.6873 17.5957 23.7714 17.8607 22.9091H8.48485V3.27273H27.1515V16.3734C28.3571 16.4278 29.5027 16.7125 30.5455 17.1845V0H5.09091V22.9091H0V27.8182C0 29.1818 0.494949 30.3409 1.48485 31.2955ZM10.1818 8.18182V11.4545H25.4545V8.18182H10.1818ZM10.1818 13.0909V16.3636H25.4545V13.0909H10.1818Z",
    fill: "#422163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0927 19.6367C25.6952 19.6367 26.1836 20.1251 26.1836 20.7276L26.1836 29.4549C26.1836 30.0574 25.6952 30.5458 25.0927 30.5458C24.4902 30.5458 24.0018 30.0574 24.0018 29.4549L24.0018 20.7276C24.0018 20.1251 24.4902 19.6367 25.0927 19.6367Z",
    fill: "#422163"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5469 25.0912C30.5469 25.6937 30.0585 26.1821 29.456 26.1821H20.7287C20.1262 26.1821 19.6378 25.6937 19.6378 25.0912C19.6378 24.4887 20.1262 24.0003 20.7287 24.0003H29.456C30.0585 24.0003 30.5469 24.4887 30.5469 25.0912Z",
    fill: "#422163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/template-icon.848f4f37a81fc5080fadbbd81a719f76.svg";
export { ForwardRef as ReactComponent };